import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #333;
  color: #fff;
  padding: 4rem 2rem;
  font-size: 0.9rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FooterTitle = styled.h4`
  color: #fff;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const FooterLink = styled(Link)`
  color: #aaa;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
`;

const ExternalLink = styled.a`
  color: #aaa;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #444;
  color: #777;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <Column>
          <FooterTitle>Building on Truth</FooterTitle>
          <p style={{ color: '#aaa', lineHeight: '1.6' }}>
            Equipping Christians to engage AI, entrepreneurship, and business as a mission with biblical faithfulness.
          </p>
        </Column>

        <Column>
          <FooterTitle>Services</FooterTitle>
          <FooterLink to="/workshops">Workshops</FooterLink>
          <FooterLink to="/events">Speaking & Events</FooterLink>
          <FooterLink to="/ministry-incubators">Ministry Incubators</FooterLink>
        </Column>

        <Column>
          <FooterTitle>Ministry</FooterTitle>
          <FooterLink to="/about">About Us</FooterLink>
          <FooterLink to="/resources">Resources</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </Column>

        <Column>
          <FooterTitle>Connect</FooterTitle>
          <ExternalLink href="https://www.linkedin.com/in/aschwabe/" target="_blank" rel="noopener noreferrer">LinkedIn – Andrew</ExternalLink>
          <ExternalLink href="https://www.linkedin.com/in/joyrebecca/" target="_blank" rel="noopener noreferrer">LinkedIn – Rebecca</ExternalLink>
          <FooterLink to="/contact">Email Us</FooterLink>
        </Column>
      </FooterContent>

      <Copyright>
        &copy; {new Date().getFullYear()} Building On Truth. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
